import { Injectable } from '@angular/core';
import { ResourceType } from 'src/app/models/api';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

export enum FieldName {
  createdBy = 'createdBy',
  ownedBy = 'ownedBy',
  environment = 'environment',
}

@Injectable({
  providedIn: 'root',
})
export class TextProviderService {
  constructor(private readonly _labelsProviderPipe: LabelsProviderPipe) {}

  public getNotApplicableTableTooltipTextByResourceTypeIfNeeded(
    resourceCategory: ResourceType,
    fieldName: FieldName,
    value?: string
  ): string | undefined {
    const isCreatedByOrOwnedByField = fieldName === FieldName.createdBy || fieldName === FieldName.ownedBy;
    const isConnectorOrVirtualConnector =
      resourceCategory === ResourceType.connector || resourceCategory === ResourceType.virtual_connector;
    if (isCreatedByOrOwnedByField && isConnectorOrVirtualConnector) {
      return this._labelsProviderPipe.transform('common.platformGenerated');
    } else if (
      !value &&
      (resourceCategory === ResourceType.user ||
        resourceCategory === ResourceType.connector ||
        resourceCategory === ResourceType.virtual_connector ||
        resourceCategory === ResourceType.azure_active_directory_group)
    ) {
      return this._labelsProviderPipe.transform('common.tenantLevelResource');
    }
    return undefined;
  }
}
